export const externalUrls = {
  facebook: "https://facebook.com/MakeReadyProject",
  instagram: "https://instagram.com/theMakeReady",
  x: "https://x.com/theMakeReady",
  tikTok: "https://www.tiktok.com/@themakeready",
  youtube: "https://www.youtube.com/@themakereadyproject",
};
